<div style="display: flex; flex-direction: column; align-items: center; height: 80vh;">
    <img class="imgHome" src="assets/img/bgInter.jpg" alt="Logo" >
    <!--<h1>Bienvenido a Interconexión con Instituciones</h1> -->
</div>